Hop.defineModule('gtm', (domRoot, param) => {
    const singleDef = param.def;
    const multiDefs = param.defs;
    const domAction = param.domAction;

    if (singleDef && !validEventDef(singleDef)) {
        throw new Error('GTM module : Given event def is invalid !');
    }

    if (multiDefs && !Array.isArray(multiDefs)) {
        throw new Error('GTM module : "defs" param must be an Array !');
    }

    if (multiDefs && !multiDefs.reduce((acc, curr) => validEventDef(curr) && acc, true)) {
        throw new Error('GTM module : Given event defs are invalid');
    }

    const EVENT = domAction || detectAppropriateEvent(domRoot);

    function validEventDef(def) {
        return typeof def === 'object' && !Array.isArray(def);
    }

    function pushGtmEvents() {
        singleDef && Hop.gtm.push(singleDef);
        multiDefs && multiDefs.forEach(Hop.gtm.push);
    }

    function detectAppropriateEvent(el) {
        return el.tagName === 'FORM' ? 'submit' : 'click';
    }

    function listenToUserActions() {
        domRoot.addEventListener(EVENT, pushGtmEvents);
    }

    listenToUserActions();

    return function destroy() {
        domRoot.removeEventListener(EVENT, pushGtmEvents);
    };
});
